<template>
  <div class="agent-info-echarts container">
    <div class="title">
      <div class="main-text">一周交易总量：{{ weekPayCount }}</div>
      <div class="explain">当前展示信息为：{{ finalProductName }}</div>
    </div>
    <div id="bar1" class="echarts-div"></div>
    <div class="title">
      <div class="main-text">一周交易总额：{{ weekPayOkMoney }}</div>
      <div class="explain" />
    </div>
    <div id="bar2" class="echarts-div"></div>
  </div>
</template>

<script>
/*global PUBLIC_TOKEN,PUBLIC_REPORT_PRODUCT_ID,PUBLIC_REPORT_PRODUCT_NAME,PUBLIC_REPORT_AGENT_ID,PUBLIC_REPORT_AGENT_NAME */

import * as echarts from 'echarts';
import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { GetWeeklyReport } from '@/api/manage';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'AgentInfoEcharts',
  data() {
    return {
      myChart1: null,
      myChart2: null,
      token: PUBLIC_TOKEN || '',
      productId: PUBLIC_REPORT_PRODUCT_ID || '',
      productName: PUBLIC_REPORT_PRODUCT_NAME || '',
      agentId: PUBLIC_REPORT_AGENT_ID || '',
      agentName: PUBLIC_REPORT_AGENT_NAME || '',
      weekPayCount: 0,
      weekPayMoney: 0,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.setToken(() => {
        this.initMyChart(() => {
          this.setChartOption();
        });
      });
    });
  },
  computed: {
    finalProductName() {
      let result = '全平台';
      if (this.productId) {
        result = this.productName;
      } else {
        if (this.agentId) {
          result = this.agentName;
        }
      }
      return result;
    },
    weekPayOkMoney() {
      const payMoney = isNaN(parseFloat(this.weekPayMoney)) ? 0 : parseFloat(this.weekPayMoney);
      return payMoney > 0 ? parseFloat(payMoney / 100).toFixed(2) : payMoney;
    },
  },
  methods: {
    setToken(ok = null) {
      localStorage.setItem('token', this.token);
      ok && ok();
    },
    initMyChart(ok = null) {
      this.myChart1 = echarts.init(document.getElementById('bar1'));
      this.myChart2 = echarts.init(document.getElementById('bar2'));
      ok && ok();
    },
    setChartOption() {
      Indicator.open();
      GetWeeklyReport({ productId: this.productId, agentId: this.agentId })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              Indicator.close();
              this.weekPayCount = res.data.weekPayCount;
              this.weekPayMoney = res.data.weekPayMoney;
              const dateArr = []; // 日期
              const countArr = []; // 交易量
              const moneyArr = []; // 交易额
              res.data.dailyTradingReports.forEach(item => {
                dateArr.push(`${item.date.split(' ')[0].substr(-2)}日`); // 设置日期
                countArr.push(item.payCount); // 设置交易量
                moneyArr.push(this.getOkMoney(item.payMoney)); // 设置交易额
              });
              this.myChart1.setOption({
                title: null,
                tooltip: {},
                xAxis: {
                  data: dateArr,
                },
                yAxis: {},
                series: [
                  {
                    name: '交易量',
                    type: 'bar',
                    data: countArr,
                    color: [
                      // "#dd6b66",
                      // "#759aa0",
                      // "#e69d87",
                      // "#8dc1a9",
                      '#ea7e53',
                      // "#eedd78",
                      // "#73a373",
                      // "#73b9bc",
                      // "#7289ab",
                      // "#91ca8c",
                      // "#f49f42",
                    ],
                  },
                ],
              });
              this.myChart2.setOption({
                title: null,
                tooltip: {},
                xAxis: {
                  data: dateArr,
                },
                yAxis: {},
                series: [
                  {
                    name: '交易额',
                    type: 'bar',
                    data: moneyArr,
                    color: [
                      // "#dd6b66",
                      '#759aa0',
                      // "#e69d87",
                      // "#8dc1a9",
                      // "#ea7e53",
                      // "#eedd78",
                      // "#73a373",
                      // "#73b9bc",
                      // "#7289ab",
                      // "#91ca8c",
                      // "#f49f42",
                    ],
                  },
                ],
              });
            },
            (code, msg) => {
              Indicator.close();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    getOkMoney(money) {
      const pm = isNaN(parseFloat(money)) ? 0 : parseFloat(money);
      return pm > 0 ? parseFloat(pm / 100).toFixed(2) : pm;
    },
  },
};
</script>

<style></style>
